import platformConfig from './index.cjs';

export const { PLATFORM_URLS, LOCAL_PLATFORM_URLS, platformUrl } = platformConfig;
